<template>
  <div :class="$style['pt-sell-order-form']">
    <pt-sub-title title="订单信息"></pt-sub-title>
    <pt-form-item label="订单来源：" :labelWidth="labelWidth" :required="true">
      <el-radio-group v-model="form.salesFrom" data-vv-as="订单来源" v-validate="'required'">
        <el-radio v-for="(item,index) in labOrderSaleFrom" :key="index" :label="item.value">{{item.label}}</el-radio>
      </el-radio-group>
    </pt-form-item>
    <pt-form-item label="选择渠道：" :labelWidth="labelWidth" :required="true">
      <el-select v-model="form.clientOrganizationId" placeholder="请选择渠道" @change="branchChange">
        <el-option v-for="(item,index) in branch" :key="index" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </pt-form-item>
    <pt-form-item label="地区：" :labelWidth="labelWidth" :required="Boolean(isRequired('otherInfo.businessOriginArea',businessFrom))">
      <el-select :disabled="recollectNot_normal" placeholder="请输入地区" v-model="form.otherInfo.businessOriginArea" data-vv-as="地区" v-validate="isRequired('otherInfo.businessOriginArea',businessFrom)" filterable clearable default-first-option>
        <el-option
          v-for="item in areaOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select><span style="margin-left:10px;color:#9c9c9c">(市/省)</span>
      <!-- <el-input :disabled="recollectNot_normal" placeholder="请输入地区" v-model="form.otherInfo.businessOriginArea" data-vv-as="地区" v-validate="isRequired('otherInfo.businessOriginArea',businessFrom)"></el-input> -->
    </pt-form-item>
    <pt-form-item label="商品选择：" :labelWidth="labelWidth" :required="true">
      <el-button plain type="primary" :disabled="recollectNot_spe" @click="selectProduct">点击选择</el-button>
      <wt-input v-model="form.agentProductCode" style="display:none" v-validate="'required'" data-vv-as="商品">
      </wt-input>
      <div :class="$style['package-table-div']" class="page-background" v-if="form.agentProductCode">
        <table :class="$style['package-table']">
          <th>
          <td>商品名称</td>
          <td>套餐名称</td>
          </th>
          <tr>
            <td>{{currentProduct.name}}</td>
            <td>{{currentProduct.packageName}}</td>
          </tr>
        </table>
      </div>
    </pt-form-item>
    <pt-form-item label="产品编号：" :labelWidth="labelWidth" :required="true">
      <el-input :disabled="true" placeholder="请选择商品" v-model="form.agentProductCode" data-vv-as="产品编号"
        v-validate="'required'"></el-input>
    </pt-form-item>
    <pt-sub-title title="样本及用户信息"></pt-sub-title>
    <pt-form-item label="合同编号：" :labelWidth="labelWidth">
      <el-input placeholder="请输入合同编号" v-model="form.otherInfo.contractNumber" data-vv-as="合同编号">
      </el-input>
    </pt-form-item>
    <pt-form-item label="样本条码号：" :labelWidth="labelWidth" :required="true">
      <el-input :disabled="recollectCan_sampleId" placeholder="请输入样本条码号" v-model="form.sampleId" data-vv-as="样本条码号"
        v-validate="'required'"></el-input>
    </pt-form-item>
    <pt-form-item label="样本类型：" :labelWidth="labelWidth" :required="true" v-if="form.currentSample">
      <sample-type-selector :disabled="recollectCan_normal" v-model="form.currentSample.sampleType" data-vv-as="样本类型"
        v-validate="'required'"></sample-type-selector>
    </pt-form-item>
    <pt-form-item label="采集日期：" :labelWidth="labelWidth" :required="true">
      <el-date-picker :disabled="recollectCan_normal" v-model="form.collectTime" type="date" placeholder="选择日期"
        data-vv-as="采集日期" v-validate="'required'"></el-date-picker>
    </pt-form-item>
    <pt-form-item label="采集医院：" :labelWidth="labelWidth" :required="true">
      <el-select v-model="form.hospitalId" placeholder="请选择采集医院" :disabled="recollectCan_normal">
        <el-option v-for="(item,index) in hospital" :key="index" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </pt-form-item>
    <pt-form-item label="牙齿颗数：" :labelWidth="labelWidth" :required="true">
      <el-input placeholder="请输入牙齿颗数" v-model="form.otherInfo.numberOfTeeth" data-vv-as="牙齿颗数" v-validate="'required'" :disabled="recollectCan_normal">
      </el-input>
    </pt-form-item>
    <div :class="$style.dashed" />
    <pt-form-item label="受检者姓名：" :labelWidth="labelWidth" :required="true">
      <el-input placeholder="请输入受检者姓名" :disabled="recollectNot_normal" v-model="form.patient.name" data-vv-as="受检者姓名"
        v-validate="'required'"></el-input>
    </pt-form-item>
    <pt-form-item label="受检者性别：" :labelWidth="labelWidth" :required="true">
      <el-select v-model="form.patient.gender" placeholder="请选择受检者性别" data-vv-as="受检者性别" v-validate="'required'" :disabled="recollectNot_normal">
        <el-option label="女" value="FEMALE"></el-option>
        <el-option label="男" value="MALE"></el-option>
      </el-select>
    </pt-form-item>
    <pt-form-item label="受检者身份证号：" :labelWidth="labelWidth">
      <el-input placeholder="请输入受检者身份证号" v-model="form.patient.identityCard" @blur="validateIDCard"></el-input>
    </pt-form-item>
    <pt-form-item label="受检者民族：" :labelWidth="labelWidth">
      <el-input placeholder="请输入受检者民族" v-model="form.patient.nation"></el-input>
    </pt-form-item>
    <pt-form-item label="手机号：" :labelWidth="labelWidth" :required="true">
      <el-input :disabled="recollectNot_normal" placeholder="请输入手机号" v-model="form.patient.mobile" data-vv-as="手机号"
       v-validate="'required|phone'"></el-input>
    </pt-form-item>
    <pt-form-item label="出生日期：" :labelWidth="labelWidth" :required="birthdayRequried">
      <el-date-picker :disabled="recollectNot_normal" v-model="form.patient.birthday" type="date" placeholder="选择日期"
        data-vv-as="出生日期" v-validate="birthdayRequried ? 'required' :''"></el-date-picker>
    </pt-form-item>
    <pt-form-item label="年龄：" :labelWidth="labelWidth" :required="ageRequried">
      <el-input :disabled="recollectNot_normal" placeholder="请输入年龄" v-model="form.patient.age" data-vv-as="年龄"
        v-validate="ageRequried ? 'required' :''"></el-input>
    </pt-form-item>
    <div :class="$style.dashed" />
    <pt-form-item label="C端用户：" :labelWidth="labelWidth">
      <el-input placeholder="请输入C端用户" v-model="form.otherInfo.mallOrderPlacerNickName">
      </el-input>
    </pt-form-item>
    <pt-form-item label="手机号：" :labelWidth="labelWidth">
      <el-input placeholder="请输入手机号" v-model="form.otherInfo.mallOrderPlacerPhone">
      </el-input>
    </pt-form-item>
    <!-- 选择代理商商品餐 -->
    <agent-product-dialog :dialogVisible="showDialog" @close="closeDefaultDialog" @selectData="selectData"
      :agentId="form.clientOrganizationId" :pageSize="5" :productId="form.agentProductCode" :data="agentData">
    </agent-product-dialog>
  </div>
</template>

<script>
// 组件class前缀
import agentProductDialog from './agent-product-dialog'
import sampleTypeSelector from 'cps/lab-order/pt-lab-order-form/sample-type-selector'
import formMixins from 'mixins/form'
import _ from '@/utils/typeof.js'
import {
  labOrderSaleFrom
} from 'json/adult-sell-order'
import { isRequired } from './form-required-option'
const prefixCls = 'pt-sell-order-form'
export default {
  name: 'pt-sell-order-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    // 如果是false就是没权限, 啥都不能编辑,true的话都能编辑
    canEditOrder () {
      return this.value.canEditOrder
    },
    // 特殊字段（生产条码号、套餐、渠道）能否编辑
    canEditOrderSpe () {
      return this.value.canEditOrderContent && this.value.canEditOrder
    },
    // 样本ID能否编辑（只有是商城的订单并且样本接收前能）
    canEditSampleId () {
      return this.value.canEditSampleId && this.value.canEditOrder
    },
    // 只要重采就不能改，其他情况按canEditOrder处理
    recollectNot_normal () {
      if (!this.isEdit) {
        return false
      }
      return this.recollect ? true : !this.canEditOrder
    },
    // 只要重采就不能改，其他情况按canEditOrder处理
    recollectNot_spe () {
      if (!this.isEdit) {
        return false
      }
      return this.recollect ? true : !this.canEditOrderSpe
    },
    // 只要重采就能改，其他情况按canEditOrder处理
    recollectCan_normal () {
      if (!this.isEdit) {
        return false
      }
      return this.recollect ? false : !this.canEditOrder
    },
    // 只要重采就能改，其他情况按canEditSampleId处理, 注：只是针对样本ID
    recollectCan_sampleId () {
      if (!this.isEdit) {
        return false
      }
      return this.recollect ? false : !this.canEditSampleId
    },
    businessFrom () {
      if (!this.isEdit) {
        return 'AGENT'
      }
      return this.value.businessFrom
    },
    birthdayRequried () {
      if (this.businessFrom === 'MALL') {
        return true
      } else {
        if (this.form.patient.age === 0) {
          return false
        }
        return !this.form.patient.age
      }
    },
    ageRequried () {
      if (this.businessFrom === 'MALL') {
        return false
      } else {
        return !this.form.patient.birthday
      }
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    hospital: {
      type: Array,
      default: () => []
    },
    branch: {
      type: Array,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    // 是否时重采订单
    recollect: {
      type: Boolean,
      default: false
    }
  },
  components: {
    sampleTypeSelector,
    agentProductDialog
    // organizationSelector
  },
  data () {
    return {
      labOrderSaleFrom: labOrderSaleFrom,
      labelWidth: '150px',
      form: this.value.id ? this.value : {
        agentProductCode: '', // 6141001
        patient: {
          identityCardType: 'CHINESE_IDENTITY_CARD'
        },
        otherInfo: {},
        // detectionPackageIds: '',
        currentSample: {}
      },
      address: null,
      showDialog: false,
      currentProduct: {},
      agentData: {},
      areaOptions: null// 地区的选项
    }
  },
  watch: {
    value (val) {
      this.form = JSON.parse(JSON.stringify(val))
      // let { provinceGbCode, cityGbCode, districtGbCode } = val.patient
      // this.address = { provinceGbCode, cityGbCode, districtGbCode }
      this.address = {}
      this.address.provinceName = val.patient.reportReceivingProvince
      this.address.cityName = val.patient.reportReceivingCity
      this.address.districtName = val.patient.reportReceivingDistrict
      this.address.postAddress = val.patient.reportReceivingAddress
      this.currentProduct = {
        name: this.form.otherInfo.mallOrderName,
        packageName: this.form.detectionPackageNames[0]
      }
      this.agentData = this.getAgentProduct(val)
    },
    form (val) {
      this.$emit('input', JSON.parse(JSON.stringify(val)))
    },
    'address' (val) {
      this.form.patient.reciveAddress = JSON.parse(JSON.stringify(val))
    },
    'form.patient.identityCard' (val) {
      this.IDCardChange(val)
    },
    branch (val) {
      val && this.branchChange(this.form.clientOrganizationId)
    }
  },
  methods: {
    isRequired,
    branchChange (val) {
      let res = this.branch.filter(item => item.value === val)[0]
      /* global _ */
      if (res && _.isArray(res.addresses)) {
        this.areaOptions = res.addresses.map(e => {
          if (e) {
            return {
              label: e,
              value: e
            }
          }
        })
      }
    },
    changeOgz () {
      // this.form.detectionPackageIds = ''
      this.form.agentProductCode = ''
      this.currentProduct = {}
      this.agentData = {}
    },
    getAgentProduct (val) {
      let res = {}
      res.name = val.otherInfo.mallOrderName
      res.packages = {
        // packageId: val.detectionPackageIds,
        packageName: val.detectionPackageNames && val.detectionPackageNames.length ? val.detectionPackageNames[0] : null
      }
      res.productCode = val.agentProductCode
      return res
    },
    IDCardChange (val) {
      // 18位时自动验证
      let patient = this.form.patient
      if (patient && patient.identityCardType === 'CHINESE_IDENTITY_CARD' && val && val.length === 18) {
        this.validateIDCard()
      }
    },
    validateIDCard () {
      let patient = this.form.patient
      if (patient && patient.identityCardType === 'CHINESE_IDENTITY_CARD' && patient.identityCard) {
        let info = this.$getIdCardInfo(patient.identityCard)
        if (JSON.stringify(info) !== '{}') {
          let {
            gender,
            birthday
          } = info
          this.form.patient.gender = gender
          this.form.patient.birthday = birthday
        }
      }
    },
    selectProduct () {
      this.showDialog = true
    },
    closeDefaultDialog () {
      this.showDialog = false
    },
    selectData (val) {
      console.log('val----', val)
      this.currentProduct = val
      this.currentProduct.packageName = val.packages.packageName
      // this.form.detectionPackageIds = val.packages.packageId
      this.form.agentProductCode = val.productCode
      console.log('this.form', this.form)
      this.closeDefaultDialog()
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .pt-sell-order-form {
    :global {

      .el-input,
      .el-input__inner {
        max-width: 2.8rem;
        height: 0.4rem;
        line-height: 0.4rem;
      }

      .el-input--suffix .el-input__inner {
        min-width: 2.8rem;
      }

      .el-upload--picture-card,
      .el-upload-list--picture-card .el-upload-list__item {
        width: 117px;
        height: 155px;
      }

      el-textarea,
      .el-textarea__inner {
        width: 500px;
      }

      .wt-upload-file {
        line-height: 0;
        margin-top: 10px;
      }
    }

    .address {
      :global {

        .el-select .el-input,
        .el-input__inner {
          height: .4rem !important;
        }
      }
    }

    .upload-file-text {
      line-height: 155px;
    }

    .dashed {
      margin: 30px 0;
      height: 1px;
      background-image: linear-gradient(to right, #ccc 0%, #ccc 50%, transparent 50%);
      background-size: 8px 1px;
      background-repeat: repeat-x;
    }

    .package-table-div {
      margin-top: 10px;
      padding: 10px 20px 30px;
      max-width: 800px;
    }

    .package-table {
      display: table !important;
      width: 100%;
      border-collapse: collapse !important;

      th,
      tr {
        width: 100% !important;
        max-width: 100% !important;
        display: table-row;
        padding: 0 !important;
        list-style-type: none;
        border-bottom: 1px solid #C6C9D3;
        color: #818181
      }

      td {
        text-align: left;
      }
    }
  }

</style>
